import React from "react";
import { FileInfoStrip, FileNo, Owner, RiskType, Status } from "../StyledComp";

const FileStrip = ({ ltpDetail, mapDetailsFromSession }) => {
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo?.info?.roles?.map((e) => e.code);

  // Role detection logic
  const isLtp = userRoles?.some((role) => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role));
  const isOwner = userRoles?.includes("OWNER") && !isLtp;
  const isCitizen = userRoles?.includes("LTP");
  const roleLabel = isLtp ? "LTP Mobile No" : isOwner ? "Owner Mobile No" : isCitizen ? "Citizen Mobile No" : "Mobile No";
  return (
    <FileInfoStrip>
      {mapDetailsFromSession?.applicationNo && <FileNo>File No: {mapDetailsFromSession?.applicationNo || "N/A"}</FileNo>}
      <span>{roleLabel}:-&nbsp;</span> <span style={{ fontWeight: "bold" }}>{userInfo?.info?.mobileNumber || "N/A"}</span>
      <Owner>
        <strong>{userInfo?.info?.name}</strong>
        <div style={{ fontWeight: "normal", fontSize: "0.9em" }}>{ltpDetail?.registrationNumber}</div>
      </Owner>
    </FileInfoStrip>
  );
};

export default FileStrip;
